import React from 'react';
import { withTheme } from '@cloudflare/style-container';
import { Trans } from '@cloudflare/intl-react';

var LogoInline = _ref => {
  var {
    theme,
    light,
    width = '200px',
    height = '46px'
  } = _ref;
  var textColor = light ? theme.colors.white : theme.colors.black;
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 1179.5 271.2",
    width: width,
    height: height,
    "aria-label": "title desc"
  }, /*#__PURE__*/React.createElement("title", null, /*#__PURE__*/React.createElement(Trans, {
    id: "accessibility.header.logo.title",
    _: "Cloudflare Logo"
  })), /*#__PURE__*/React.createElement("desc", null, /*#__PURE__*/React.createElement(Trans, {
    id: "accessibility.header.logo.desc",
    _: "Navigate Back"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: textColor,
    points: "503.2,155.6 518.7,155.6 518.7,198.1 545.9,198.1 545.9,211.7 503.2,211.7   "
  }), /*#__PURE__*/React.createElement("path", {
    fill: textColor,
    d: "M562,183.8v-0.2c0-16.1,13-29.2,30.3-29.2c17.3,0,30.1,12.9,30.1,29v0.2c0,16.1-13,29.2-30.3,29.2    C574.8,212.9,562,200,562,183.8 M606.5,183.8v-0.2c0-8.1-5.8-15.1-14.4-15.1c-8.5,0-14.2,6.9-14.2,15v0.2    c0,8.1,5.8,15.1,14.3,15.1C600.9,198.8,606.5,191.9,606.5,183.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: textColor,
    d: "M641.4,187.1v-31.5h15.8v31.2c0,8.1,4.1,11.9,10.3,11.9c6.2,0,10.3-3.7,10.3-11.5v-31.6h15.8v31.1    c0,18.1-10.3,26-26.3,26C651.5,212.8,641.4,204.7,641.4,187.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: textColor,
    d: "M717.5,155.6h21.6c20,0,31.7,11.5,31.7,27.7v0.2c0,16.2-11.8,28.2-32,28.2h-21.3V155.6z M739.4,198    c9.3,0,15.5-5.1,15.5-14.2v-0.2c0-9-6.2-14.2-15.5-14.2H733V198H739.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: textColor,
    points: "793.4,155.6 838.2,155.6 838.2,169.3 808.9,169.3 808.9,178.8 835.4,178.8 835.4,191.7 808.9,191.7     808.9,211.7 793.4,211.7   "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: textColor,
    points: "859.9,155.6 875.4,155.6 875.4,198.1 902.6,198.1 902.6,211.7 859.9,211.7   "
  }), /*#__PURE__*/React.createElement("path", {
    fill: textColor,
    d: "M943.2,155.2h15l23.9,56.5h-16.7l-4.1-10h-21.6l-4,10h-16.3L943.2,155.2z M956.8,189.6l-6.2-15.9l-6.3,15.9    H956.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: textColor,
    d: "M1002.1,155.6h26.5c8.6,0,14.5,2.2,18.3,6.1c3.3,3.2,5,7.5,5,13.1v0.2c0,8.6-4.6,14.3-11.5,17.2l13.4,19.6    h-18l-11.3-17h-6.8v17h-15.5V155.6z M1027.9,182.6c5.3,0,8.3-2.6,8.3-6.7v-0.2c0-4.4-3.2-6.7-8.4-6.7h-10.2v13.5H1027.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: textColor,
    points: "1074.3,155.6 1119.4,155.6 1119.4,168.9 1089.7,168.9 1089.7,177.4 1116.6,177.4 1116.6,189.6     1089.7,189.6 1089.7,198.5 1119.8,198.5 1119.8,211.7 1074.3,211.7   "
  }), /*#__PURE__*/React.createElement("path", {
    fill: textColor,
    d: "M469.1,190.4c-2.2,4.9-6.8,8.4-12.8,8.4c-8.5,0-14.3-7.1-14.3-15.1v-0.2c0-8.1,5.7-15,14.2-15    c6.4,0,11.3,3.9,13.3,9.3h16.4c-2.6-13.4-14.4-23.3-29.6-23.3c-17.3,0-30.3,13.1-30.3,29.2v0.2c0,16.1,12.8,29,30.1,29    c14.8,0,26.4-9.6,29.4-22.4H469.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: theme.colors.marketing.lightOrange,
    d: "M328.6,125.6c-0.8,0-1.5,0.6-1.8,1.4l-4.8,16.7c-2.1,7.2-1.3,13.8,2.2,18.7    c3.2,4.5,8.6,7.1,15.1,7.4l26.2,1.6c0.8,0,1.5,0.4,1.9,1c0.4,0.6,0.5,1.5,0.3,2.2c-0.4,1.2-1.6,2.1-2.9,2.2l-27.3,1.6    c-14.8,0.7-30.7,12.6-36.3,27.2l-2,5.1c-0.4,1,0.3,2,1.4,2h93.8c1.1,0,2.1-0.7,2.4-1.8c1.6-5.8,2.5-11.9,2.5-18.2    c0-37-30.2-67.2-67.3-67.2C330.9,125.5,329.7,125.5,328.6,125.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: theme.colors.marketing.orange,
    d: "M292.8,204.4c2.1-7.2,1.3-13.8-2.2-18.7c-3.2-4.5-8.6-7.1-15.1-7.4l-123.1-1.6    c-0.8,0-1.5-0.4-1.9-1s-0.5-1.4-0.3-2.2c0.4-1.2,1.6-2.1,2.9-2.2l124.2-1.6c14.7-0.7,30.7-12.6,36.3-27.2l7.1-18.5    c0.3-0.8,0.4-1.6,0.2-2.4c-8-36.2-40.3-63.2-78.9-63.2c-35.6,0-65.8,23-76.6,54.9c-7-5.2-15.9-8-25.5-7.1    c-17.1,1.7-30.8,15.4-32.5,32.5c-0.4,4.4-0.1,8.7,0.9,12.7c-27.9,0.8-50.2,23.6-50.2,51.7c0,2.5,0.2,5,0.5,7.5    c0.2,1.2,1.2,2.1,2.4,2.1h227.2c1.3,0,2.5-0.9,2.9-2.2L292.8,204.4z"
  })));
};

export default withTheme(LogoInline);